import { render } from "./x6_two_bottles.vue?vue&type=template&id=7d79d498&scoped=true"
import script from "./x6_two_bottles.vue?vue&type=script&lang=js"
export * from "./x6_two_bottles.vue?vue&type=script&lang=js"

import "./x6_two_bottles.vue?vue&type=style&index=0&id=7d79d498&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d79d498"]])

export default __exports__